import { useState, ChangeEvent, ReactNode, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import AppModal from "../AppModal";

interface CSVModalProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (file: File | null) => void;
  title: string;
  formatDetails: ReactNode;
  sampleFileUrl?: string;
  sampleFileName?: string;
  text?: string;
  downloadText?: string;
  handleDownload?: () => void;
  onFileUpload?: (id: number, file: File) => void;
  websiteId?: number;
}

export default function CSVModal({
  open,
  handleClose,
  handleConfirm,
  handleDownload,
  onFileUpload,
  title,
  websiteId,
  formatDetails,
  sampleFileUrl,
  sampleFileName,
  text = "💡 Download example format:",
  downloadText = "Download Sample CSV",
}: CSVModalProps) {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0] || null;
    setFile(selected);

    if (onFileUpload && selected && websiteId) {
      onFileUpload(websiteId, selected);
    }
  };

  let download = () => {};

  if (sampleFileName && sampleFileUrl) {
    download = () => {
      const link = document.createElement("a");
      link.href = sampleFileUrl;
      link.download = sampleFileName;
      link.click();
    };
  }
  if (handleDownload) {
    download = handleDownload;
  }
  useEffect(() => {
    if (!open) {
      setFile(null);
    }
  }, [open]);

  return (
    <AppModal
      title={title}
      open={open}
      handleClose={handleClose}
      onSubmit={() => handleConfirm(file)}
      action="Continue"
    >
      <p>Please ensure your CSV file follows this format:</p>
      <ul>{formatDetails}</ul>

      <p>{text}</p>
      <Button variant="link" onClick={download}>
        {downloadText}
      </Button>

      <Form.Group className="mt-3">
        <Form.Label>Upload your CSV file</Form.Label>
        <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        {file && (
          <small className="text-success mt-1">✅ {file.name} selected</small>
        )}
      </Form.Group>
    </AppModal>
  );
}
